import styles from "./Stepper.module.scss";
import { TiTick } from "react-icons/ti";
import React from "react";

interface Props {
  showLabel: boolean;
  currentStep: number;
  steps: Array<{
    id: number;
    label?: string;
  }>;
}

function Stepper(props: Props) {
  const { steps, currentStep, showLabel = true } = props;

  const stepRenderer = (stepNo: number) => {
    if (stepNo < currentStep) {
      return (
        <div className={styles.completedStep}>
          <div className={styles.iconContainer}>
            <TiTick color="white" size={15} />
          </div>
        </div>
      );
    }
    if (stepNo === currentStep) {
      return (
        <div className={styles.activeStep}>
          <div className={styles.circle}></div>
        </div>
      );
    }

    if (stepNo > currentStep) {
      return (
        <div className={styles.step}>
          <div className={styles.circle}></div>
        </div>
      );
    }

    return <></>;
  };

  return (
    <div className={styles.mainContainer}>
      {steps?.map((item, i) => {
        return (
          <div key={i} className={styles.stepContainer}>
            <div className={styles.stepWrapper}>
              {stepRenderer(i)}
              {i < steps.length - 1 && <div className={styles.connector}></div>}
            </div>
            {showLabel && <p className={styles.label}>{item?.label}</p>}
          </div>
        );
      })}
    </div>
  );
}

export default Stepper;
